import React from 'react';
import { FormattedMessage } from 'react-intl';

interface ResultCounterProps {
  productCount: number;
}

const ResultCounter: React.FC<ResultCounterProps> = ({ productCount = 0 }) => {
  return (
    <div className="text-text-secondary text-sm leading-5">
      <FormattedMessage
        id="cdp:general:products"
        values={{
          amount: productCount,
        }}
      />
    </div>
  );
};

export default ResultCounter;
